import { getKeycloak } from "./keycloak"
import { LOGIN_TIME_KEY } from "../context/UserContext";
import { reportAuthAuditEvent } from "../services/authService";

/**
 * Performs a complete logout from Keycloak and clears local authentication
 * @param {string} redirectUri - Where to redirect after logout (defaults to home)
 * @returns {Promise<void>}
 */
export async function keycloakLogout(redirectUri = window.location.origin) {
  try {
    await reportAuthAuditEvent("logout");
    // Clear localStorage token
    localStorage.removeItem('authToken')
    sessionStorage.removeItem(LOGIN_TIME_KEY)
    
    // Get Keycloak instance
    const kc = getKeycloak()
    
    if (kc && kc.authenticated) {
      // Perform Keycloak logout with redirect
      await kc.logout({ redirectUri })
    } else {
      // If not authenticated, just redirect
      window.location.href = redirectUri
    }
  } catch (error) {
    console.error('Keycloak logout error:', error)
    
    // Fallback: clear storage and redirect
    localStorage.removeItem('authToken')
    sessionStorage.removeItem(LOGIN_TIME_KEY)
    window.location.href = redirectUri
  }
}

/**
 * Clears all authentication-related data
 */
export function clearAuthData() {
  localStorage.removeItem('authToken')
  localStorage.removeItem('user')
  localStorage.removeItem('userProfile')
  sessionStorage.removeItem(LOGIN_TIME_KEY)
}

/**
 * Gets the current authentication token
 * @returns {string|null} The JWT token or null if not authenticated
 */
export function getAuthToken() {
  return localStorage.getItem('authToken')
}

/**
 * Checks if user is authenticated
 * @returns {boolean} True if authenticated
 */
export function isAuthenticated() {
  const kc = getKeycloak()
  return kc && kc.authenticated
}

/**
 * Gets user profile from Keycloak
 * @returns {object|null} User profile object or null
 */
export function getUserProfile() {
  const kc = getKeycloak()
  if (kc && kc.authenticated && kc.idTokenParsed) {
    return {
      id: kc.idTokenParsed.sub,
      username: kc.idTokenParsed.preferred_username,
      email: kc.idTokenParsed.email,
      name: kc.idTokenParsed.name,
      givenName: kc.idTokenParsed.given_name,
      familyName: kc.idTokenParsed.family_name,
    }
  }
  return null
}
